<nb-card accent="success">
  <nb-card-header>
    <div class="d-flex">
      <div class="flex-grow-1 d-flex align-items-center justify-content-center">
        <nb-icon icon="edit-outline" *ngIf="action === 'edit'"></nb-icon>
        <nb-icon icon="plus-outline" *ngIf="action !== 'edit'"></nb-icon>
        <div class="ml-2" *ngIf="action === 'edit'" i18n>Editing Campaign: {{ campaign.id }}</div>
        <div class="ml-2" *ngIf="action === 'clone'" i18n>Cloning Campaign</div>
        <div class="ml-2" *ngIf="action === 'create'" i18n>Creating Campaign</div>
      </div>
      <button nbButton class="ml-3" (click)="close()">
        <nb-icon icon="close-outline"></nb-icon>
      </button>
    </div>
  </nb-card-header>
  <nb-card-body style="min-width: 750px">
    <form #campaignForm="ngForm">
      <strong class="text-uppercase" i18n>Campaign Details</strong>
      <hr />

      <div class="row">
        <div class="col-3">
          <label i18n>Campaign Name<span style="color: red">*</span>:</label>
        </div>
        <div class="col-9">
          <input
            nbInput
            ngbAutofocus
            id="name"
            type="text"
            fullWidth
            placeholder="Campaign Name"
            i18n-placeholder
            name="name"
            #name="ngModel"
            required
            [(ngModel)]="campaign.name"
            [appValidRegex]="thisRegex"
          />
          <div *ngIf="(name?.touched || name?.dirty) && name?.errors?.required" class="error" i18n>
            Name is a required field
          </div>
          <div *ngIf="name.errors?.validRegex" class="error" i18n>
            The first character must be alphanumeric, and up to 128 letters (uppercase and lowercase), numbers, hyphens,
            and underscores are allowed.
          </div>
        </div>
      </div>
      <br />

      <div class="row">
        <div class="col-3"><label i18n>Description:</label></div>
        <div class="col-9">
          <textarea id="description" [(ngModel)]="campaign.description" name="description" nbInput fullWidth rows="3">
          </textarea>
        </div>
      </div>
      <br />

      <div class="row">
        <div class="col-3">
          <label
            nbTooltip="Real-time campaigns are triggered by events (e.g., MissionCancelationEvent,
            MissionEndEvent) and do not require an Insight."
            i18n-nbTooltip
            i18n
            >Real Time:</label
          >
        </div>
        <div class="col-9">
          <input
            type="checkbox"
            [ngModel]="campaign.is_real_time"
            name="is_real_time"
            (change)="isRealTimeChanged($event)"
          />
        </div>
      </div>
      <br />

      <div class="row">
        <div class="col-3">
          <label i18n>Insight<span style="color: red">*</span>:</label>
        </div>
        <div class="col-6">
          <ng-select
            id="insight"
            name="insight"
            placeholder="Select Insight"
            i18n-placeholder
            [(ngModel)]="campaign.trigger_id"
            style="width: 105%"
            required
            #insight="ngModel"
            [disabled]="hideInsightSelect"
          >
            <ng-option *ngFor="let insight of insight$ | async" [value]="insight.id">
              {{ insight.name }}
            </ng-option>
          </ng-select>
          <div *ngIf="(insight?.touched || insight?.dirty) && insight?.errors?.required" class="error" i18n>
            Insight Name is a required field
          </div>
        </div>
        <div class="col-3">
          <button
            *ngIf="campaign.trigger_id"
            nbButton
            size="medium"
            ghost
            status="info"
            (click)="editInsight(campaign.trigger_id)"
          >
            <nb-icon icon="external-link-outline" nbTooltip="View Insight" i18n-nbTooltip></nb-icon>
          </button>
        </div>
      </div>
      <br />

      <div class="row">
        <div class="col-3"><label i18n>Campaign Type:</label></div>
        <div class="col-9">
          <ng-select
            id="campaign_type"
            name="campaign_type"
            placeholder="Select Campaign Type"
            i18n-placeholder
            [(ngModel)]="campaign.campaign_type"
            style="width: 68%"
            dropdownPosition="top"
          >
            <ng-option *ngFor="let campaign of campaignTypes" [value]="campaign.value">{{ campaign.name }}</ng-option>
          </ng-select>
        </div>
      </div>
      <br />

      <div class="row">
        <div class="col-3"><label i18n>Event Triggers:</label></div>
        <div class="col-9">
          <ng-select
            id="campaign_event_triggers"
            name="campaign_event_triggers"
            placeholder="Select Campaign Event Triggers"
            i18n-placeholder
            [(ngModel)]="campaign.event_triggers"
            style="width: 68%"
            [multiple]="true"
          >
            <ng-option *ngFor="let eventTrigger of eventTrigger$ | async" [value]="eventTrigger">
              {{ eventTrigger }}
            </ng-option>
          </ng-select>
        </div>
      </div>
      <br />

      <div class="row">
        <div class="col-3"><label i18n>Campaign Category:</label></div>
        <div class="col-9">
          <ng-select
            id="campaign_category"
            name="campaign_category"
            placeholder="Select campaign category"
            i18n-placeholder
            [(ngModel)]="campaign.category"
            style="width: 68%"
          >
            <ng-option *ngFor="let campaignCategory of campaignCategories" [value]="campaignCategory.value">
              {{ campaignCategory.name }}
            </ng-option>
          </ng-select>
        </div>
        <br />
      </div>
      <br />

      <div class="row">
        <div class="col-3"><label i18n>Campaign Subcategory:</label></div>
        <div class="col-9">
          <ng-select
            id="campaign_subcategory"
            name="campaign_subcategory"
            placeholder="Select campaign subcategory"
            i18n-placeholder
            [(ngModel)]="campaign.subcategory"
            style="width: 68%"
          >
            <ng-option *ngFor="let campaignSubCategory of campaignSubCategories" [value]="campaignSubCategory.value">
              {{ campaignSubCategory.name }}
            </ng-option>
          </ng-select>
        </div>
        <br />
      </div>
      <br />

      <div class="row">
        <div class="col">
          <nb-toggle
            status="success"
            id="show_condition"
            name="show_condition"
            [(ngModel)]="show_condition"
            nbTooltip="Set a condition on which campaigns robot needs to or not receive"
            i18n-nbTooltip
            nbTooltipPlacement="right"
            [(checked)]="show_condition"
          >
            <strong class="text-uppercase" i18n>Conditional Campaign</strong>
          </nb-toggle>
        </div>
      </div>
      <div *ngIf="show_condition">
        <hr />
        <div class="row">
          <div class="col-3">
            <nb-checkbox
              id="show_condition_all"
              name="show_condition_all"
              [(ngModel)]="show_condition_all"
              nbTooltip="Robot has received notifications from ALL of these campaigns"
              i18n-nbTooltip
              nbTooltipPlacement="right"
            >
              <strong class="text-uppercase" i18n>ALL</strong>
            </nb-checkbox>
          </div>
          <div class="col-9" *ngIf="show_condition_all">
            <ng-select
              id="condition_all"
              name="condition_all"
              placeholder="Select campaigns"
              i18n-placeholder
              [(ngModel)]="condition_all"
              style="width: 68%"
              [multiple]="true"
              [closeOnSelect]="false"
              [searchable]="true"
            >
              <ng-option *ngFor="let c of campaigns" [value]="c.id">
                {{ c.name }}
              </ng-option>
            </ng-select>
          </div>
        </div>
        <br />
        <div class="row">
          <div class="col-3">
            <nb-checkbox
              id="show_condition_any"
              name="show_condition_any"
              [(ngModel)]="show_condition_any"
              nbTooltip="Robot has received notifications from ANY of these campaigns"
              i18n-nbTooltip
              nbTooltipPlacement="right"
            >
              <strong class="text-uppercase" i18n>ANY</strong>
            </nb-checkbox>
          </div>
          <div class="col-9" *ngIf="show_condition_any">
            <ng-select
              id="condition_any"
              name="condition_any"
              placeholder="Select campaigns"
              i18n-placeholder
              [(ngModel)]="condition_any"
              style="width: 68%"
              [multiple]="true"
              [closeOnSelect]="false"
              [searchable]="true"
            >
              <ng-option *ngFor="let c of campaigns" [value]="c.id">
                {{ c.name }}
              </ng-option>
            </ng-select>
          </div>
        </div>
        <br />
        <div class="row">
          <div class="col-3">
            <nb-checkbox
              id="show_condition_not_all"
              name="show_condition_not_all"
              [(ngModel)]="show_condition_not_all"
              nbTooltip="Robot has NOT received notifications from ALL of these campaigns"
              i18n-nbTooltip
              nbTooltipPlacement="right"
            >
              <strong class="text-uppercase" i18n>NOT ALL</strong>
            </nb-checkbox>
          </div>
          <div class="col-9" *ngIf="show_condition_not_all">
            <ng-select
              id="condition_not_all"
              name="condition_not_all"
              placeholder="Select campaigns"
              i18n-placeholder
              [(ngModel)]="condition_not_all"
              style="width: 68%"
              [multiple]="true"
              [closeOnSelect]="false"
              [searchable]="true"
            >
              <ng-option *ngFor="let c of campaigns" [value]="c.id">
                {{ c.name }}
              </ng-option>
            </ng-select>
          </div>
        </div>
        <br />
        <div class="row">
          <div class="col-3">
            <nb-checkbox
              id="show_condition_not_any"
              name="show_condition_not_any"
              [(ngModel)]="show_condition_not_any"
              nbTooltip="Robot has NOT received notifications from ANY of these campaigns"
              i18n-nbTooltip
              nbTooltipPlacement="right"
            >
              <strong class="text-uppercase" i18n>NOT ANY</strong>
            </nb-checkbox>
          </div>
          <div class="col-9" *ngIf="show_condition_not_any">
            <ng-select
              id="condition_not_any"
              name="condition_not_any"
              placeholder="Select campaigns"
              i18n-placeholder
              [(ngModel)]="condition_not_any"
              style="width: 68%"
              [multiple]="true"
              [closeOnSelect]="false"
              [searchable]="true"
            >
              <ng-option *ngFor="let c of campaigns" [value]="c.id">
                {{ c.name }}
              </ng-option>
            </ng-select>
          </div>
        </div>
        <br />
        <div class="row">
          <div class="col-3">
            <label i18n>Time Frame (Days)<span style="color: red">*</span>:</label>
          </div>
          <div class="col-9">
            <input
              id="time_frame"
              name="time_frame"
              placeholder="90"
              type="number"
              min="1"
              [max]="campaign.frequency_days"
              class="form-control form-control-sm"
              [(ngModel)]="time_frame"
              #timeFrame="ngModel"
              nbInput
              style="width: 68%"
            />
            <div *ngIf="time_frame > campaign.frequency_days" class="error" i18n>
              Time frame must be less than or equal to campaign frequency
            </div>
          </div>
        </div>
        <br />
      </div>
      <br />

      <strong class="text-uppercase" i18n>Push Notifications</strong>
      <hr />
      <div class="row">
        <div class="col-3"><label i18n>Push Notifications:</label></div>
        <div class="col-9">
          <ng-select
            id="push_info"
            name="push_info"
            placeholder="Select push type"
            i18n-placeholder
            [(ngModel)]="campaign.push_notification_type"
            style="width: 68%"
          >
            <ng-option *ngFor="let pushType of pushNotificationTypes" [value]="pushType">
              {{ pushType | replaceunderscore | titlecase }}
            </ng-option>
          </ng-select>
        </div>
        <br />
      </div>
      <br />

      <div *ngIf="campaign.push_notification_type === 'push_dynamic'" class="row">
        <div class="col-3"><label i18n>Metadata Type:</label></div>
        <div class="col-9">
          <ng-select
            id="metadata_type"
            name="metadata_type"
            placeholder="Select metadata type"
            i18n-placeholder
            [(ngModel)]="campaign.metadata_type"
            style="width: 68%"
          >
            <ng-option *ngFor="let metadataType of metadataTypes" [value]="metadataType.value">
              {{ metadataType.name | replaceunderscore | titlecase }}
            </ng-option>
          </ng-select>
        </div>
        <br />
      </div>
      <br />

      <strong class="text-uppercase" i18n>Content</strong>
      <hr />
      <div class="row">
        <div class="col-3">
          <label i18n>Content ID<span style="color: red">*</span>:</label>
        </div>
        <div class="col-6">
          <ng-select
            name="content"
            placeholder="Select Content"
            i18n-placeholder
            [(ngModel)]="campaign.content_id"
            #content_id="ngModel"
            required
            style="width: 105%"
          >
            <ng-option *ngFor="let content of content$ | async" [value]="content.content_id">
              {{ content.content_id }}
            </ng-option>
          </ng-select>
          <div *ngIf="(content_id?.touched || content_id?.dirty) && content_id?.errors?.required" class="error" i18n>
            Content ID is a required field
          </div>
        </div>
        <div class="col-3">
          <button
            *ngIf="campaign.content_id"
            nbButton
            size="medium"
            ghost
            status="info"
            (click)="editContent(campaign.content_id)"
          >
            <nb-icon icon="external-link-outline" nbTooltip="View Content" i18n-nbTooltip></nb-icon>
          </button>
        </div>
      </div>
      <br />
      <div class="row">
        <div class="col-3">
          <label i18n>Campaign Channel:</label>
        </div>
        <div class="col-9">
          <ng-select
            name="channel"
            placeholder="Select Channel"
            i18n-placeholder
            [(ngModel)]="campaign.channel"
            style="width: 68%"
          >
            <ng-option *ngFor="let campaignChannel of campaignChannels" [value]="campaignChannel.value">
              {{ campaignChannel.name }}</ng-option
            >
          </ng-select>
        </div>
      </div>
      <br />

      <strong class="text-uppercase" i18n>Survey</strong>
      <hr />
      <div class="row">
        <div class="col-3"><label i18n>Survey ID:</label></div>
        <div class="col-9">
          <ng-select
            [multiple]="true"
            [closeOnSelect]="false"
            [searchable]="false"
            placeholder="Select Surveys"
            i18n-placeholder
            [(ngModel)]="selectedSurveys"
            name="survey"
            style="width: 68%"
            bindLabel="name"
            [items]="allSurveys"
            [compareWith]="compareSurveys"
          >
          </ng-select>
        </div>
      </div>
      <br />

      <strong class="text-uppercase" i18n>Action Details</strong>
      <hr />

      <div class="row">
        <div class="col-3">
          <label i18n>Frequency (Days)<span style="color: red">*</span>:</label>
        </div>
        <div class="col-9">
          <input
            id="frequency_days"
            name="frequency_days"
            placeholder="90"
            type="number"
            min="1"
            class="form-control form-control-sm"
            [(ngModel)]="campaign.frequency_days"
            #frequencyDays="ngModel"
            required
            nbInput
            style="width: 100%"
          />
          <div
            *ngIf="(frequencyDays?.touched || frequencyDays?.dirty) && frequencyDays?.errors?.required"
            class="error"
            i18n
          >
            Frequency is a required field
          </div>
        </div>
      </div>
      <br />
    </form>
  </nb-card-body>
  <nb-card-footer>
    <div class="d-flex justify-content-end">
      <button nbButton (click)="close()" i18n>Close</button>
      <button
        nbButton
        class="ml-3"
        status="success"
        [disabled]="!campaignForm.valid || (show_condition && !time_frame)"
        (click)="save()"
        i18n
      >
        Save
      </button>
    </div>
  </nb-card-footer>
</nb-card>
